
import { reactive, inject, computed, onMounted, watch } from "vue";
import axios from "@/services/axios";
import ResearchCategorySelectionData from "@/modules/research-category-selection-data";
import ResearchOrganizationCreationDto from "@/modules/research-organization/research-organization-creation-dto";
import ResearchOrganizationRepositoryAPI from "@/modules/research-organization/research-organization-repository-api";
import { useI18n } from "vue-i18n";
import { location } from "@/utils/default-data";
import ResearchInfrastructureRepositoryAPI from "@/modules/research-infrastructure/research-infrastructure-repository-api";

export default {
  props: {
    editMode: Boolean,
  },
  setup(props: any) {
    const { t } = useI18n();
    const toast: any = inject("toast");
    const isEditModeEnabled = props.editMode as boolean;

    const state = reactive({
      users: [],
      filteredUsers: [],
      researchInfrastructureGroup: [] as Array<any>,
      documentUploadDialog: false,
      confirmationDialog: false,
      selectedBookingDocumentIndex: -1,
      selectedResearchOrganization: {},
      organizationDto: {
        latitude: location.lat,
        longitude: location.lng,
        street: location.address,
        postalCode: location.postalCode,
        department: location.department,
      } as ResearchOrganizationCreationDto,
    });

    const { getResearchCategories, loadEquipmentCategories } =
      ResearchCategorySelectionData();

    const { getSelectedResearchOrganization } =
      ResearchOrganizationRepositoryAPI();

    const { researchInfrastructureState } =
      ResearchInfrastructureRepositoryAPI();

    onMounted(() => {
      loadUsers();
      loadEquipmentCategories();
    });

    watch(
      () => getSelectedResearchOrganization.value,
      (newValue) => {
        if (false === isEditModeEnabled) {
          return;
        }
        state.organizationDto = newValue;
        state.organizationDto.cityId = newValue.cityId;
        state.organizationDto.userIds = newValue.users.map(
          (item: any) => item?.id
        );
        state.organizationDto.researchInfrastructureIds =
          newValue.researchInfrastructures.map((item: any) => item?.id);

        state.filteredUsers = state.users.filter(
          (item: any) => item.researchOrganizationId === newValue.id
        );
      }
    );

    async function loadUsers() {
      const response = await axios.get("api/v1/User?PageNumber=0&PageSize=500");
      state.users = response.data;
    }

    const onResearchOrganizationCreateClick = () => {
      if (!state.organizationDto.latitude || !state.organizationDto.longitude) {
        state.organizationDto.latitude = location.lat;
        state.organizationDto.longitude = location.lng;
      }

      if (isEditModeEnabled) {
        axios
          .put(
            `/api/v1/ResearchOrganization/${state.organizationDto.id}`,
            state.organizationDto
          )
          .then((response) => {
            if (response.status === 204) {
              const summaryText = `${state.organizationDto.name} posodobljena`;
              notificationDisplay(
                "success",
                `Raziskovalna organizacija`,
                summaryText
              );
            }
          })
          .catch((error) => {
            const response = error.response;
            notificationDisplay(
              "warn",
              `Raziskovalna organizacija`,
              `${response.statusText}: ${response.data.message}`
            );
          });
        return;
      }
      axios
        .post("/api/v1/ResearchOrganization", state.organizationDto)
        .then((response: any) => {
          if (response.status === 201) {
            state.organizationDto = {} as ResearchOrganizationCreationDto;
            const summaryText = `${response.data.name} dodana`;
            notificationDisplay(
              "success",
              `Raziskovalna organizacija`,
              summaryText
            );
          }
        })
        .catch((error) => {
          const response = error.response;
          notificationDisplay(
            "warn",
            `Raziskovalna organizacija`,
            `${response.statusText}: ${response.data.message}`
          );
        });
    };

    const notificationDisplay = (
      severity: string,
      summary: string,
      detail: string
    ): void => {
      toast.add({
        severity: severity,
        summary: summary,
        detail: detail,
        life: 3000,
      });
    };

    return {
      t,
      state: state,
      researchInfrastructureState: researchInfrastructureState,
      getResearchCategories: getResearchCategories,
      onResearchOrganizationCreateClick,

      locationData: computed(() => {
        return {
          lat: state.organizationDto?.latitude || location.lat,
          lng: state.organizationDto?.longitude || location.lng,
        } as any;
      }),
    };
  },
};
